(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-addon-products"]) return;
  try {
    
  (function () {
    function initCartAddonProductsSwiper() {
      if (typeof Swiper === 'undefined') {
        requestAnimationFrame(initCartAddonProductsSwiper);
        return;
      }
      document.querySelectorAll('.cart-addon-products-swiper').forEach(function (el) {
        if (el.dataset.swiperInitialized === 'true') return;
        el.dataset.swiperInitialized = 'true';
        var wrap = el.closest('.cart-addon-products__swiper-wrap');
        if (!wrap) return;
        var paginationEl = wrap.querySelector('.swiper-pagination');
        var nextEl = wrap.querySelector('.swiper-button-next');
        var prevEl = wrap.querySelector('.swiper-button-prev');
        new Swiper(el, {
          slidesPerView: 1,
          spaceBetween: 16,
          watchOverflow: true,
          breakpointsBase: 'container',
          breakpoints: {
            360: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            700: {
              slidesPerView: 3,
              spaceBetween: 30,
            },
          },
          pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
          navigation: nextEl && prevEl ? { nextEl: nextEl, prevEl: prevEl } : false,
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initCartAddonProductsSwiper);
    } else {
      initCartAddonProductsSwiper();
    }

    // The cart page swaps this section's markup back in via innerHTML after every
    // add/remove/quantity change (cart.js fires this event once the new markup is in),
    // so re-run init for the freshly injected swiper.
    document.addEventListener('cart:sections-rendered', initCartAddonProductsSwiper);

    // Theme editor re-renders the section without re-running this script.
    document.addEventListener('shopify:section:load', initCartAddonProductsSwiper);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      if (typeof Swiper === 'undefined') {
        requestAnimationFrame(init);
        return;
      }
      document.querySelectorAll('.collection-carousel-swiper').forEach(function (el) {
        if (el.dataset.swiperInitialized === 'true') return;
        el.dataset.swiperInitialized = 'true';
        var wrap = el.closest('.collection-carousel__swiper-wrap');
        if (!wrap) return;
        var paginationEl = wrap.querySelector('.swiper-pagination');
        var nextEl = wrap.querySelector('.swiper-button-next');
        var prevEl = wrap.querySelector('.swiper-button-prev');
        var autoplay = el.dataset.autoplay === 'true';
        var speedSec = parseInt(el.dataset.speed, 10) || 5;
        new Swiper(el, {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 16,
          breakpoints: {
            650: {
              slidesPerView: 2,
              spaceBetween: 24,
            },
            1000: {
              slidesPerView: 3,
              spaceBetween: 60,
            },
          },
          autoplay: autoplay ? { delay: speedSec * 1000, disableOnInteraction: false } : false,
          pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
          navigation: nextEl && prevEl ? { nextEl: nextEl, prevEl: prevEl } : false,
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      if (typeof Swiper === 'undefined') {
        requestAnimationFrame(init);
        return;
      }
      document.querySelectorAll('.content-carousel-swiper').forEach(function (el) {
        if (el.dataset.swiperInitialized === 'true') return;
        el.dataset.swiperInitialized = 'true';
        var wrap = el.closest('.content-carousel__swiper-wrap');
        if (!wrap) return;
        var paginationEl = wrap.querySelector('.swiper-pagination');
        var nextEl = wrap.querySelector('.swiper-button-next');
        var prevEl = wrap.querySelector('.swiper-button-prev');
        new Swiper(el, {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 16,
          breakpoints: {
            750: {
              slidesPerView: 2,
              spaceBetween: 34,
            },
            900: {
              slidesPerView: 3,
              spaceBetween: 34,
            },
          },
          pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
          navigation: nextEl && prevEl ? { nextEl: nextEl, prevEl: prevEl } : false,
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.megaMenuWrapper = document.querySelector('.autify-mega-menu-wrapper');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.megaMenuWrapper) this.megaMenuWrapper.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.megaMenuWrapper) this.megaMenuWrapper.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        if (this.megaMenuWrapper) this.megaMenuWrapper.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      if (typeof Swiper === 'undefined') {
        requestAnimationFrame(init);
        return;
      }
      document.querySelectorAll('.product-carousel-swiper').forEach(function (el) {
        if (el.dataset.swiperInitialized === 'true') return;
        el.dataset.swiperInitialized = 'true';
        var wrap = el.closest('.product-carousel__swiper-wrap');
        if (!wrap) return;
        var paginationEl = wrap.querySelector('.swiper-pagination');
        var nextEl = wrap.querySelector('.swiper-button-next');
        var prevEl = wrap.querySelector('.swiper-button-prev');
        var autoplay = el.dataset.autoplay === 'true';
        var speedSec = parseInt(el.dataset.speed, 10) || 5;
        new Swiper(el, {
          loop: false,
          slidesPerView: 1,
          spaceBetween: 16,
          breakpoints: {
            650: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            900: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
            1250: {
              slidesPerView: 4,
              spaceBetween: 30,
            },
          },
          autoplay: autoplay ? { delay: speedSec * 1000, disableOnInteraction: false } : false,
          pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
          navigation: nextEl && prevEl ? { nextEl: nextEl, prevEl: prevEl } : false,
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-articles"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const slider = document.querySelectorAll('.slider__slide');
    const section_wrapper = document.querySelector('.section-related-articles');

    if (slider.length > 0) {
      section_wrapper.style.display = 'block';
    } else {
      section_wrapper.style.display = 'none';
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  window.initRelatedProductsSwiper = function (container) {
    if (typeof Swiper === 'undefined') return;
    var root = container || document;
    root.querySelectorAll('.related-products-swiper').forEach(function (el) {
      if (el.dataset.swiperInitialized === 'true') return;
      el.dataset.swiperInitialized = 'true';
      var wrap = el.closest('.related-products__swiper-wrap');
      if (!wrap) return;
      var paginationEl = wrap.querySelector('.swiper-pagination');
      var nextEl = wrap.querySelector('.swiper-button-next');
      var prevEl = wrap.querySelector('.swiper-button-prev');
      new Swiper(el, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 16,
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: 24,
          },
          990: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
        },
        pagination: paginationEl ? { el: paginationEl, clickable: true } : false,
        navigation: nextEl && prevEl ? { nextEl: nextEl, prevEl: prevEl } : false,
      });
    });
  };
  (function () {
    function init() {
      window.initRelatedProductsSwiper(document);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
